import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';
import { Box, Chip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import UnassignedField from '@/components/global/fields/UnassignedField.jsx';
import { DrawerLink } from '@/components/global/drawers/DrawerLink';

const StyledDeviceCollectionPointField = styled(Box)(({ theme }) => ({
    '& .pos-field-name': {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        [theme.breakpoints.up('sm')]: {
            flexWrap: 'nowrap',
        },
        '& p': {
            fontSize: '14px',
        },
        '& .pos-field-name-id': {
            whiteSpace: 'nowrap',
        },
        '& .pos-field-name-contractor': {
            whiteSpace: 'nowrap',
            marginRight: '8px',
        },
        '& .pos-field-name-chip': {
            [theme.breakpoints.up('sm')]: {
                marginTop: '0',
                flexWrap: 'nowrap',
            },
        },
    },
    '& .pos-field-info': {
        marginTop: '4px',
        [theme.breakpoints.up('lg')]: {
            marginTop: 0,
            fontSize: 'inherit',
        },
        '& .pos-field-address': {
            marginBottom: '-2px',
        },
        '& p': {
            margin: '0px',
        },
    },
    '& .pos-field-phone': {
        fontWeight: 400,
        margin: '0px',
    },
    '& .unassigned-field': {
        marginTop: '20px',
    },
}));

const DeviceCollectionPointField = ({ collectionPoint }) => {
    const translate = useTranslate();

    return collectionPoint ? (
        <StyledDeviceCollectionPointField className='device-pos-field' onClick={e => e.stopPropagation()}>
            <DrawerLink
                resource='collection-point'
                source={collectionPoint.id}
                action='show'
                relative
                label={
                    <Box>
                        <Box className='pos-field-name'>
                            <Typography variant='body2' className='pos-field-name-id'>
                                <strong>{collectionPoint.customId}</strong>,&nbsp;
                            </Typography>
                            <Typography variant='body2' className='pos-field-name-contractor'>
                                {collectionPoint.contractor.name}
                            </Typography>
                            {collectionPoint.premiumService && (
                                <Chip size='small' label={translate('resources.device.labels.premiumService')} className='pos-field-name-chip chip-small' />
                            )}
                        </Box>
                        <Box className='pos-field-info' sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Typography variant='body2' className='pos-field-address'>
                                {collectionPoint.address.address}
                                {collectionPoint.address.postalCode ? `, ${collectionPoint.address.postalCode} ${collectionPoint.address.city}` : null}
                            </Typography>
                            <Typography variant='body2' className='pos-field-phone'>
                                {collectionPoint.contact.contactPhoneNumber}
                            </Typography>
                            {collectionPoint.contact.employeePhoneNumber && (
                                <Typography variant='body2' className='pos-field-phone'>
                                    {collectionPoint.contact.employeePhoneNumber} {translate('resources.device.labels.employeePhoneNumber')}
                                </Typography>
                            )}
                        </Box>
                    </Box>
                }
            />
        </StyledDeviceCollectionPointField>
    ) : (
        <UnassignedField />
    );
};

const DeviceCollectionPointModel = PropTypes.shape({
    id: PropTypes.string.isRequired,
    contractorId: PropTypes.string.isRequired,
    serviceCompanyId: PropTypes.string,
    contractor: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
    }).isRequired,
    customId: PropTypes.string.isRequired,
    premiumService: PropTypes.bool.isRequired,
    address: PropTypes.shape({
        address: PropTypes.string.isRequired,
        city: PropTypes.string.isRequired,
        postalCode: PropTypes.string.isRequired,
        country: PropTypes.string.isRequired,
    }).isRequired,
    contact: PropTypes.shape({
        contactPhoneNumber: PropTypes.string.isRequired,
        employeePhoneNumber: PropTypes.string,
    }).isRequired,
});

DeviceCollectionPointField.propTypes = {
    collectionPoint: DeviceCollectionPointModel,
};

export default DeviceCollectionPointField;
